import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MiscModule } from '../../../misc.module';
import { HomePageRoutingModule } from './home-routing.module';
import { HomePageComponent } from './home.page';

@NgModule({
  declarations: [HomePageComponent],
  imports: [FormsModule, IonicModule, HomePageRoutingModule, MiscModule, CommonModule]
})
export class HomePageModule {}
